import axios from 'axios';

const api = axios.create({
  baseURL: "https://global.thewillowquantum.com/"
});

export default api;